import { render, staticRenderFns } from "./Specifiche2.vue?vue&type=template&id=026198e0&scoped=true&"
import script from "./Specifiche2.vue?vue&type=script&lang=js&"
export * from "./Specifiche2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026198e0",
  null
  
)

export default component.exports